import React, { useState, useEffect } from "react";

import editIcon from "../../../../../../Assets/icons/Un-Checkbox.svg";
import addIcon from "../../../../../../Assets/icons/addIconLogistics.svg";
import deleteIcon from "./../../../../../../Assets/icons/trash.svg";
import { useAsyncError, useNavigate } from "react-router-dom";
import CustomTable from "../../../../../customComponents/CustomTable";
import axiosInstance from "../../../../../services/api/API";
import backicon from "../../../../../../Assets/icons/backIcon.svg";
import eyeIcon from "../../../../../../Assets/icons/eye 1.svg";
//import "./PhysicalStockin.scss";

import Drawer from "react-modern-drawer";

import "react-modern-drawer/dist/index.css";
import PurchaseVehicle from "../PurchaseOrderComponents/PurchaseVehicle";
import PurchaseSparePart from "../PurchaseOrderComponents/PurchaseSparePart";
import PurchaseAccessories from "../PurchaseOrderComponents/PurchaseAccesories";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";

const PurchaseOrder = ({
  stockTypesData,
  PhysicalStockinId,
  vendorId,
  potype,
  po_id,
  bpid,
  is_approved,
  fetchPurchaseOrderDetails=()=>{}
}) => {
  console.log("is_approved", is_approved);

  const [formData, setFormData] = useState({});
  const [physicalStockData, setphysicalStockData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [PurchaseOrderList, setPurchaseOrderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);
  const [podetailsID, setPODetailsId] = useState(0);
  const [serialDrawer, setSerialDrawer] = useState(false);
  const [isSerailDrawerOpen, setIsSerialDrawerOpen] = useState(false);
  const [serialData, setSerialData] = useState([]);
  const [itemType,setItemType] = useState("")
  const [VendorID,setVendorID] = useState();

  console.log(stockTypesData, "stockTypesData");

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    if(isEdit){
      setIsEdit(!isEdit)
      setFormData({})
    }
    
    setFormData({})
  
  };
  const toggleSerialDrawer = () => {
    setIsSerialDrawerOpen((prevState) => !prevState);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPurchaseOrderList(newPage);
  };
  const PO_TABLE_HEADERS = [
    "Name",
    "Logistic Type",
    "Product Name",
    "Sub Product Name",
    "Make",
    "Vendor Name",
    "Variant",
    "Quantity",
    "Price",
    "Total Amount",
  ];
  
  if (is_approved !== 1) {
    PO_TABLE_HEADERS.push("Action"); 
  }
  
  const poKeyMapping = {
    Name: "name",
    "Logistic Type": "itemtypename",
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    Make: "make_name",
    "Vendor Name": "companyname",
    Variant: "variant_name",
    Quantity: "quantity",
    Price: "rate",
    "Total Amount": "totalprice",
  };
  
  // Conditionally add the 'Action' key based on is_approved
  if (is_approved !== 1) {
    poKeyMapping.Action = [
      { type: "edit", icon: editIcon, label: "Edit" },
    ];
  }
  

  useEffect(() => {
    fetchPurchaseOrderList();
  }, [po_id]);

  const fetchPurchaseOrderList = async (page = 0, pageSize = 10) => {
  
    try {
      const response = await axiosInstance.post(
        `/podetails/list`,
        { po_id: po_id, orderBy: "po_details_id asc", page, pageSize },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response?.data?.data?.data;
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalRecords(totalRecordsData);
      setPurchaseOrderList(fetchedData);
      console.log("PurchaseOrderList", PurchaseOrderList);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Table headers
  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Variant Name",
    "Item Name",
    "Item Type",
    "Make",
    "Model",
    "Price",
    "Goods Quantity",
    "Total Price",
    "Action",
  ];

  // Key mapping for CustomTable component
  const DEPARTMENT_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Department ID": "department_id",
    "Variant Name": "variant_name",
    "Item Name": "item_name",
    "Item Type": "itemtypename",
    Make: "make_name",
    Model: "model_name",
    Price: "rate",
    "Goods Quantity": "good_qty",
    "Total Price": "total_price",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "delete", icon: deleteIcon, label: "Delete" },
      { type: "addserial", icon: addIcon, label: "Add" },
    ],
  };
  const handleEdit = (rowData) => {
    console.log("rowData???", rowData);
    setVendorID(rowData?.vendor_onboard_id)
    if(is_approved !==1){
    setPODetailsId(rowData?.po_details_id);
    setIsEdit(true);
    if (rowData?.itemtype === "V") {
      setItemType("vehicle")
      setActiveComponent("vehicle");
      
    } else if (rowData?.itemtype === "A") {
      setItemType("accessory")
      setActiveComponent("accessory");
    
    } else {
      setItemType("spareparts")
      setActiveComponent("spareparts");
     
    }

    toggleDrawer();
  }
  };

  console.log("activeComponent", activeComponent);
  useEffect(() => {
    if (stockTypesData && stockTypesData.length > 0) {
        setActiveComponent(stockTypesData[0]);
    }
}, [stockTypesData])
   
  return (
    <div>
      <div className="tableWrapper">
        <div className="admin-list-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              /* padding-left: 20px; */ gap: "20px",
            }}
          >
            <h5>{potype}</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search Name"
                value={searchTerm}
                onChange={handleSearchInputChange}
              />
              {/* <img src={searchIcon} alt="Search" className="searchinput-icon" /> */}
            </div>
          </div>
          {is_approved !== 1 && stockTypesData.length > 0 && (
  <div>
    <button
      className="addcustomerbutton"
      onClick={() => {
        setIsEdit(false);
        setFormData({});
        toggleDrawer();
      }}
    >
      Add
    </button>
  </div>
)}
{
  stockTypesData?.length<=0 && potype!="Part Specific" &&
  <div>
    <span>No Stock Available</span>
  </div>
}
{potype === "Part Specific" &&  is_approved !== 1 &&(
  <div>
    <button
      className="addcustomerbutton"
      onClick={() => {
      navigate(ROUTES_NAVIGATION.PARTSPECIFIC,{state:{poID:po_id}})
      }}
    >
      Add
    </button>
  </div>
)}

        </div>


        <Drawer
  size={600}
  open={isOpen}
  onClose={toggleDrawer}
  direction="right"
  className="bla bla bla"
>
  <div style={{ padding: "30px" }}>
    <div className="backbutton">
      <img src={backicon} alt="back" />
      <span className="backbtntitleDetails">
        {isEdit ? "Update Logistic Type" : "Add Logistic Type"}
      </span>
    </div>

    <div>
      <div
        className="d-flex jus align-items-center pt-3 flex-row gap-4"
        style={{ paddingLeft: "20px" }}
      >
        {isEdit ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
            }}
            onClick={() => {
              setActiveComponent(itemType); // itemType should be the value of the item being edited
            }}
          >
            <input
              type="radio"
              name="activeComponent"
              checked={activeComponent === itemType}
              onChange={() => setActiveComponent(itemType)}
              className="form-check-input"
            />
            {itemType?.charAt(0).toUpperCase() + itemType?.slice(1)}{" "}
            {/* Capitalize the first letter */}
          </div>
        ) : (
          stockTypesData.length>0&&
          stockTypesData?.map((type, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
              }}
              onClick={() => {
                setActiveComponent(type);
                setFormData({})
              }}
            >
              <input
                type="radio"
                name="activeComponent"
                checked={activeComponent === type}
                onChange={() => setActiveComponent(type)}
                className="form-check-input"
              />
              {type.charAt(0).toUpperCase() + type.slice(1)}{" "}
              {/* Capitalize the first letter */}
            </div>
          ))
        )}
      </div>

      <div style={{ paddingLeft: "20px" }}>
        {activeComponent === "vehicle" && (
          <div className="mt-3">
            <PurchaseVehicle
              PhysicalStockinId={PhysicalStockinId}
              vendorId={vendorId}
              VendorID={VendorID}
              formData={formData}
              setFormData={setFormData}
              isEdit={isEdit}
              podetailsID={podetailsID}
              activeComponent={"vehicle"}
              toggleDrawer={toggleDrawer}
              po_id={po_id}
              bpid={bpid}
              fetchPurchaseOrderList={fetchPurchaseOrderList}
              fetchPurchaseOrderDetails={fetchPurchaseOrderDetails}
            />
          </div>
        )}
        {activeComponent === "spareparts" && (
          <div className="mt-3">
            <PurchaseSparePart
              PhysicalStockinId={PhysicalStockinId}
              vendorId={vendorId}
              activeComponent={"spareparts"}
              isEdit={isEdit}
              VendorID={VendorID}
              toggleDrawer={toggleDrawer}
              podetailsID={podetailsID}
              setIsEdit={setIsEdit}
              formData={formData}
              setFormData={setFormData}
              po_id={po_id}
              bpid={bpid}
              fetchPurchaseOrderList={fetchPurchaseOrderList}
              fetchPurchaseOrderDetails={fetchPurchaseOrderDetails}

            />
          </div>
        )}
        {activeComponent === "accessory" && (
          <div className="mt-3">
            <PurchaseAccessories
              PhysicalStockinId={PhysicalStockinId}
              vendorId={vendorId}
              VendorID={VendorID}
              activeComponent={"accessory"}
              isEdit={isEdit}
              formData={formData}
              toggleDrawer={toggleDrawer}
              setFormData={setFormData}
              podetailsID={podetailsID}
              setIsEdit={setIsEdit}
              po_id={po_id}
              bpid={bpid}
              fetchPurchaseOrderList={fetchPurchaseOrderList}
              fetchPurchaseOrderDetails={fetchPurchaseOrderDetails}

            />
          </div>
        )}
      </div>
    </div>
  </div>
</Drawer>

        <CustomTable
          data={PurchaseOrderList}
          headers={PO_TABLE_HEADERS}
          keyMapping={poKeyMapping}
          itemsPerPage={10}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          totalPages={totalPages}
          currentPage={currentPage}
          onEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default PurchaseOrder;
